/** API 時間顯示格式工具。 */

const TAIPEI_TIME_ZONE = 'Asia/Taipei';

// 後端 LocalDateTime 統一代表 UTC，但 JSON 本身不含 Z；在這裡補上時區資訊。
export function parseApiDate(value) {
  if (!value) return null;
  const raw = String(value).trim();
  const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw);
  const date = new Date(hasTimeZone ? raw : `${raw}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

function taipeiParts(value) {
  const date = parseApiDate(value);
  if (!date) return null;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TAIPEI_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  return Object.fromEntries(parts.map(part => [part.type, part.value]));
}

export function fmtTime(value) {
  const p = taipeiParts(value);
  return p ? `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}` : '';
}

export function fmtDateTaipei(value) {
  const p = taipeiParts(value);
  return p ? `${p.year}/${p.month}/${p.day}` : '';
}
